import { render, staticRenderFns } from "./stock_wait.vue?vue&type=template&id=2136c7f2"
import script from "./stock_wait.vue?vue&type=script&lang=js"
export * from "./stock_wait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports